import { LoadingSpinner } from "./components/LoadingSpinner";
import { MegaMenu } from "./components/MegaMenu";
import './components/MigrationNotice/styles.css';
import './styles.css';

const menuClass = '.header-micro-nav';
const dropdownClass = '.header-micro';
const loadingTimeoutMs = 1500;

window.addEventListener('load', () => {
    // Attach a MegaMenu to the header
    new MegaMenu(menuClass, dropdownClass);

    // Global spinner handling for elements with classname
    LoadingSpinner.registerNavigationEvents('.display-loader-on-navigation');
})

window.addEventListener('beforeunload', () => {
    // Global spinner handling for page loads that take a lot of time
    setTimeout(() => LoadingSpinner.show(), loadingTimeoutMs);
})

window.addEventListener('unload', () => {
    // Spinner must be hidden to not become visible again when pressing "back" in browser
    LoadingSpinner.hide();
})
